import './index.scss'
import React from 'react'
import { Route, BrowserRouter, Switch } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import ScrollToTop from './common/scroll_to_top'
import Home from './home'
import Pricing from './pricing'
import Privacy from './privacy'
import About from './our_story'
import Eula from './eula'
import PlusPage from './plus'
import BlogIndex from './blog'
import Changelog from './changelog'
import BlogPost from './blog/post'
import BreakReminderApp from './break_reminder_app'
import NotFound from './not_found'
import ComparePage from './compare'
import { COMPARE_SLUGS } from './compare/pages'
import AnnouncementBanner from './common/announcement_banner'
import { LangProvider } from './lib/i18n'
import { NON_DEFAULT_LANGS } from './lib/locale'
import theme from './theme'

const LANG = `:lang(${NON_DEFAULT_LANGS.join('|')})?`

export default function App({ Router = BrowserRouter }) {
  return (
    <Router>
      <ScrollToTop>
        <ThemeProvider theme={theme}>
          <LangProvider>
            <AnnouncementBanner />
            <main>
              <Switch>
                <Route exact path="/plus" component={PlusPage} />
                <Route exact path={`/${LANG}/break-reminder-app`} component={BreakReminderApp} />
                <Route exact path={`/${LANG}/blog`} component={BlogIndex} />
                <Route exact path={`/blog/:slug(${COMPARE_SLUGS.join('|')})`} component={ComparePage} />
                <Route exact path={`/${LANG}/blog/:slug`} component={BlogPost} />
                <Route exact path={`/${LANG}/changelog`} component={Changelog} />
                <Route exact path={`/${LANG}/pricing`} component={Pricing} />
                <Route exact path={`/${LANG}/privacy`} component={Privacy} />
                <Route exact path={`/${LANG}/about`} component={About} />
                <Route exact path={`/${LANG}/eula`} component={Eula} />
                <Route exact path={`/${LANG}`} component={Home} />
                <Route component={NotFound} />
              </Switch>
            </main>
          </LangProvider>
        </ThemeProvider>
      </ScrollToTop>
    </Router>
  )
}
